export default __webpack_public_path__ + "static/media/asu-logo.ecaada37.png";